import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl21 } from '../../../models'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { useBefehlForm } from '../../../hooks'
import { Befehl21FormData, createBefehl21FormValidationSchema } from './schema'
import {
  convertBefehl21FormDataToModel,
  convertModelToBefehl21FormData
} from './converters'
import Auftrag21_10Form from './Auftrag21_10Form'
import Auftrag21_12_13Form from './Auftrag21_12_13Form'

export default function Befehl21Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-21-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl21>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl21FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl21FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl21FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl21FormData) => {
      const updatedBefehl = convertBefehl21FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl21FormData>
      befehlKennung="21"
      title={t('befehle.21.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      <div className="flex flex-col gap-2">
        <Auftrag21_10Form
          readOnly={readOnly}
          data-testid={`${testId}-auftrag-21-10`}
          activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        />

        <Auftrag21_12_13Form
          readOnly={readOnly}
          data-testid={`${testId}-auftrag-21-12-13`}
          activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        />
      </div>
    </BefehlFormWrapper>
  )
}
